export const ANIMATION_FUSION = 'FUSION';
export const ANIMATION_FINAL = 'FINAL';
export const ANIMATION_MIXED = 'MIXED';
export const ANIMATION_NEW = 'NEW';
export const ANIMATION_CLEAR = 'CLEAR';
export const ANIMATION_REVERT = 'REVERT';
export const ANIMATION_GAME_END = 'GAME_END';
export const ANIMATION_GAME_COMPLETION = 'GAME_COMPLETION';
